import { useQuery } from "@apollo/client";
import { GET_CAROUSEL_INFO } from "./queries";

export const useGetCarousel = () => {
  const { data, error, loading } = useQuery(GET_CAROUSEL_INFO);

  return {
    loading: loading,
    data: data?.getCurrentPromos,
    error: error
  };
};
